"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TablePaginationActions = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _FirstPage = _interopRequireDefault(require("@material-ui/icons/FirstPage"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));

var _LastPage = _interopRequireDefault(require("@material-ui/icons/LastPage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TablePaginationActions = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TablePaginationActions, _React$Component);

  var _super = _createSuper(TablePaginationActions);

  function TablePaginationActions() {
    var _this;

    (0, _classCallCheck2.default)(this, TablePaginationActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFirstPageButtonClick", function (event) {
      _this.props.onChangePage(event, 0);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBackButtonClick", function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNextButtonClick", function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLastPageButtonClick", function (event) {
      _this.props.onChangePage(event, Math.max(0, Math.ceil(_this.props.count / _this.props.rowsPerPage) - 1));
    });
    return _this;
  }

  (0, _createClass2.default)(TablePaginationActions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          count = _this$props.count,
          page = _this$props.page,
          rowsPerPage = _this$props.rowsPerPage,
          classes = _this$props.classes;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-tablePagination-left-buttons", classes.leftButtons)
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        id: "".concat(id, "-first-page-button"),
        className: "prmbl-tablePagination-first",
        onClick: this.handleFirstPageButtonClick,
        disabled: page === 0,
        "aria-label": "First Page"
      }, /*#__PURE__*/_react.default.createElement(_FirstPage.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        id: "".concat(id, "-back-page-button"),
        className: "prmbl-tablePagination-back",
        onClick: this.handleBackButtonClick,
        disabled: page === 0,
        "aria-label": "Previous Page"
      }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null))), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-tablePagination-state", classes.paginationState)
      }, "Page ", page + 1, " of ", Math.ceil(count / rowsPerPage)), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-tablePagination-right-buttons", classes.rightButtons)
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        id: "".concat(id, "-next-page-button"),
        className: "prmbl-tablePagination-next",
        onClick: this.handleNextButtonClick,
        disabled: page >= Math.ceil(count / rowsPerPage) - 1,
        "aria-label": "Next Page"
      }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        id: "".concat(id, "-last-page-button"),
        className: "prmbl-tablePagination-last",
        onClick: this.handleLastPageButtonClick,
        disabled: page >= Math.ceil(count / rowsPerPage) - 1,
        "aria-label": "Last Page"
      }, /*#__PURE__*/_react.default.createElement(_LastPage.default, null))));
    }
  }]);
  return TablePaginationActions;
}(_react.default.Component);

exports.TablePaginationActions = TablePaginationActions;
(0, _defineProperty2.default)(TablePaginationActions, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The total number of rows in the table
   */
  count: _propTypes.default.number.isRequired,

  /**
   * Call back for when the page is changed
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * Current page shown on the table
   */
  page: _propTypes.default.number.isRequired,

  /**
   * Total number of rows per page
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(TablePaginationActions, "defaultProps", {
  className: ""
});

var _default = (0, _styles.withStyles)(_styles2.styles)(TablePaginationActions);

exports.default = _default;